import { logToDataLayer } from './LogHelper';

export const logSearch = (loggingData, cruise) => {
  if (loggingData && cruise) {
    const itinerary = cruise?.itinerary?.map((stop) => stop.resort)?.join(',');

    logToDataLayer({
      travelType: 'CruisePackage',
      eventAction: 'Search',
      event: 'Search',
      travelAction: loggingData.action || 'Search',
      travelDepartureYear: loggingData.departureDateYear || loggingData.departureYear,
      travelDepartureMonth: loggingData.departureDateMonth || loggingData.departureMonth,
      travelDepartureDay: loggingData.departureDateDay || loggingData.departureDay,
      travelDestinationCode: loggingData.destinationCode,
      travelDepartureCode: loggingData.departureCode,
      travelDuration: parseInt(loggingData.duration, 10) > 0 ? loggingData.duration : 'NoneChosen',
      travelPax: loggingData.numberOfPassengers || loggingData.pax,
      travelCountryCode: loggingData.countryCode,
      travelAdults: loggingData.numberOfAdults || loggingData.adults,
      travelAges: loggingData.passengerAges || loggingData.ages,
      travelChildren: loggingData.numberOfChildren || loggingData.children,
      travelTdmId: loggingData.tdmRuleId,
      travelTdmName: loggingData.tripRuleName,
      travelHits: loggingData.numberOfHits || loggingData.hits,
      travelHotelCode: loggingData.selectedHotelCode || loggingData.hotelCode,
      travelCruiseCode: cruise.cruiseCode,
      travelCruiseName: cruise.cruiseName,
      travelCruiseShipCode: cruise.cruiseShipCode,
      travelCruiseShipName: cruise.cruiseShipName,
      travelCruiseCompanyCode: cruise.cruiseCompanyCode,
      travelCruiseCompanyName: cruise.cruiseCompanyName,
      travelCruiseItinerary: itinerary,
      travelCruiseArea: loggingData.areaWvId,
    });
  }
};

export const logEcom = (packageData) => {
  logToDataLayer({
    event: 'detailView',
    ecommerce: {
      detail: {
        actionField: {
          list: 'CruisePackage Search Results',
        },
        products: [
          {
            name: packageData?.tripRuleName,
            id: packageData?.tdmRuleId,
            price: packageData?.totalPriceRounded,
            brand: packageData?.cruise?.cruiseCompanyName,
            category: 'CruisePackage',
            variant: 'VITS',
          },
        ],
      },
    },
  });
};
